import { LIGHT } from "../core-modules/constants";

import Box from "./Box";
import Image from "./Image";
import LogoDark from "../assets/reskinned-dark.svg";
import LogoLight from "../assets/reskinned.svg";
import Text from "./Text";
import { useBrand } from "./BrandContext";
import { useTakebackConfig } from "./TakebackConfigContext";

function ReskinnedLogo() {
  const { headerTextTheme } = useTakebackConfig();
  return (
    <Box display="flex" alignItems="center" width={[95, 160, null, null]}>
      {headerTextTheme === LIGHT ? (
        <LogoLight
          style={{ display: "block", width: "100%", height: "auto" }}
        />
      ) : (
        <LogoDark style={{ display: "block", width: "100%", height: "auto" }} />
      )}
    </Box>
  );
}

function BrandLogoLockup() {
  const { headerTextTheme } = useTakebackConfig();
  const { name, logo } = useBrand();

  return (
    <>
      <Image
        src={logo}
        alt={name}
        width="auto"
        height="auto"
        maxWidth={[90, 160, null, null]}
        objectFit="contain"
        maxHeight={64}
      />
      <Text
        color={headerTextTheme === LIGHT ? "#ffffff" : "black"}
        px={[12, 20, null, null]}
        fontSize={["10px", "16px", "16px", "16px"]}
      >
        X
      </Text>
      <ReskinnedLogo />
    </>
  );
}

function PoweredByLogoLockup() {
  let { name, poweredByLogo, poweredBySize } = useBrand();
  const { poweredByLogoOverride, poweredBySizeOverride } = useTakebackConfig();

  poweredByLogo = poweredByLogoOverride || poweredByLogo;
  poweredBySize = poweredBySizeOverride || poweredBySize;

  const logoWidth =
    poweredBySize === "small" ? [90, 160, null, null] : [280, 480, null, null];

  return (
    <>
      <Image
        src={poweredByLogo}
        alt={name}
        width="auto"
        height="auto"
        maxWidth={logoWidth}
        objectFit="contain"
        maxHeight={125}
      />
    </>
  );
}

function Nav() {
  let { logo, poweredByLogo } = useBrand();
  const { poweredByLogoOverride } = useTakebackConfig();

  poweredByLogo = poweredByLogoOverride || poweredByLogo;

  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      pt={[30, 40, null, null]}
      position="relative"
      zIndex={1}
    >
      {poweredByLogo && <PoweredByLogoLockup />}
      {logo && !poweredByLogo && <BrandLogoLockup />}
      {!logo && !poweredByLogo && <ReskinnedLogo />}
    </Box>
  );
}

export default Nav;
